import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'featured-dingliu-2026': 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20stage%20with%20a%20single%20spotlight%20on%20an%20empty%20director%20chair%2C%20atmospheric%20mysterious%20mood%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20film%20noir%20style%2C%20minimalist%20composition%2C%20warm%20amber%20spotlight%20against%20dark%20background%2C%20editorial%20photography%20quality&width=800&height=560&seq=featured-dingliu-2026&orientation=landscape',
  'featured-wanghong-2026': 'https://readdy.ai/api/search-image?query=A%20shattered%20smartphone%20screen%20on%20a%20dark%20table%20with%20broken%20glass%20pieces%20scattered%2C%20dramatic%20red%20and%20black%20lighting%2C%20chaotic%20atmosphere%2C%20metaphor%20for%20social%20media%20crisis%2C%20dark%20cinematic%20mood%2C%20editorial%20photography%2C%20high%20contrast&width=800&height=560&seq=featured-wanghong-2026&orientation=landscape',
  'featured-daoyan-2026': 'https://readdy.ai/api/search-image?query=An%20empty%20film%20set%20with%20professional%20camera%20equipment%20silhouetted%20against%20a%20dark%20studio%20background%2C%20cerie%20atmosphere%2C%20single%20overhead%20light%20casting%20long%20shadows%2C%20cinematic%20composition%2C%20film%20noir%20aesthetic%2C%20mysterious%20and%20tense%20mood&width=800&height=560&seq=featured-daoyan-2026&orientation=landscape',
};

export default function FeaturedSection() {
  return (
    <section className="relative -mt-20 z-20 max-w-7xl mx-auto px-4 md:px-6 mb-16">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {featuredArticles.map((article, index) => (
          <Link
            key={article.slug}
            to={`/article/${article.slug}`}
            className={`group relative bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
              index === 1 ? 'md:-translate-y-6' : ''
            }`}
          >
            <div className="relative h-48 md:h-56 overflow-hidden">
              <img
                src={articleImages[article.imageSeq] || ''}
                alt={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              {article.hot && (
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold flex items-center gap-1">
                  <i className="ri-fire-line text-xs"></i> 热门
                </span>
              )}
            </div>
            <div className="p-5">
              <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 px-2.5 py-1 rounded-full mb-2">
                {article.category}
              </span>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-500 line-clamp-2 mb-3">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  {article.date}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {article.views >= 10000 ? `${(article.views / 10000).toFixed(0)}万` : article.views}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}